module.exports = __webpack_public_path__ + "img/photo_230590699.97d132d5.jpg";